export const STATUS_MAP = {
  open:        { variant: 'ongoing',       labelKey: 'status_open'         },
  in_progress: { variant: 'investigation', labelKey: 'status_in_progress'  },
  resolved:    { variant: 'resolved',      labelKey: 'status_resolved'     },
  rejected:    { variant: 'rejected',      labelKey: 'status_rejected'     },
  closed:      { variant: 'resolved',      labelKey: 'status_closed'       },
};

export function claimType(reference) {
  if (!reference) return 'sinistre';
  if (reference.startsWith('LIT-')) return 'litige';
  if (reference.startsWith('SIN-')) return 'sinistre';
  return 'sinistre';
}

export function getStep(status, isSinistre) {
  const total   = isSinistre ? 5 : 4;
  const current = { open: 1, in_progress: 2, resolved: total, rejected: total, closed: total }[status] ?? 1;
  return { current, total };
}

export function fmtEur(amount) {
  if (amount == null || amount === 0) return '—';
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(amount) + ' €';
}

export function fmtDate(d, locale) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString(locale === 'en' ? 'en-GB' : 'fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function avgResolveDays(claims) {
  const closed = claims.filter((c) => c.closedAt && c.openedAt);
  if (!closed.length) return null;
  const sum = closed.reduce(
    (s, c) => s + (new Date(c.closedAt) - new Date(c.openedAt)) / 86_400_000,
    0,
  );
  return Math.round(sum / closed.length);
}
